// test476
(476 && 0);
